export default "__VITE_ASSET__5931ad7d__"